import React, { useState } from "react";
import ActiveClassNavLink from "../../routing/ActiveClassNavLink";

import { ROUTES } from "../../_constant/screens";

import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MenuOpenOutlinedIcon from "@mui/icons-material/MenuOpenOutlined";

import {
  Drawer,
  IconButton,
  List,
  ListItemIcon,
  ListItemText,
  Toolbar,
  useTheme,
} from "@mui/material";
import ListItemButton from "@mui/material/ListItemButton";
import Hidden from "../Hidden/Hidden";

import { PopoverLinkItem } from "../SettingsDrawer/SettingsDrawer";
// Same look as the Settings side bar.
import "../SettingsDrawer/SettingsDrawer.scss";

/** The Admin area's pages, in menu order. The first is where the Admin menu item lands. */
export const ADMIN_LINKS: PopoverLinkItem[] = [
  { name: "Users", url: ROUTES.ADMIN_USERS, icon: <GroupOutlinedIcon /> },
];

/** Left bar in the Admin area: picks the admin page, in place of the item filter shown elsewhere. */
const AdminDrawer: React.FC = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const selectedSx = {
    "&.Mui-selected": {
      "& > *": {
        color: theme.palette.primary.main,
      },
    },
  };

  const list = (
    <List className="SettingsDrawer__list" disablePadding aria-label="Admin pages">
      {ADMIN_LINKS.map(({ name, url, icon }) => (
        <ListItemButton
          disableGutters
          component={ActiveClassNavLink}
          to={url}
          key={name}
          activeClassName="Mui-selected"
          sx={selectedSx}
          onClick={() => setOpen(false)}
          title={name}
        >
          <ListItemIcon>{icon}</ListItemIcon>
          <ListItemText primary={name} />
        </ListItemButton>
      ))}
    </List>
  );

  return (
    <Hidden smDown implementation="css">
      <Drawer
        variant="temporary"
        anchor={theme.direction === "rtl" ? "right" : "left"}
        open={open}
        onClose={() => setOpen(false)}
      >
        <Toolbar className="SettingsDrawer__toolBar" disableGutters>
          <IconButton onClick={() => setOpen(false)} size="large" aria-label="Close admin menu">
            <MenuOpenOutlinedIcon />
          </IconButton>
        </Toolbar>
        {list}
      </Drawer>
      <Drawer variant="permanent" open className="SettingsDrawer">
        <Toolbar className="SettingsDrawer__toolBar" disableGutters>
          <IconButton onClick={() => setOpen(true)} size="large" aria-label="Open admin menu">
            <MenuOutlinedIcon />
          </IconButton>
        </Toolbar>
        {list}
      </Drawer>
    </Hidden>
  );
};

export default AdminDrawer;
